import * as Sentry from '@sentry/react';
import { APP_VERSION } from './version';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  release: `omnitower@${APP_VERSION}`,
  enabled: import.meta.env.PROD,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  tracesSampleRate: 0.2,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});
